<script>

    import { Line } from "vue-chartjs";

    export default {

        extends: Line,

        mounted() {

            this.renderChart(this.chartdata, this.options);

        },

        name: "LineChart",

        props: {
            chartdata: {
                type:Object,
                required:true,
            },
            options: {
                default:{},
                type:Object,
            },
        },

    }

</script>